import {connect} from "react-redux";
import * as AuthActions from '../../store/actions/authActions';
import * as VideoActions from '../../store/actions/videoActions';
import Sidebar from "../../components/Generals/Sidebar";
import * as SidebarActions from "../../store/actions/sidebarActions";

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.sidebar,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: () => {
        dispatch(SidebarActions.getSidebarInitialAction());
    },
    setExpandedOnHover: () => {
        dispatch(SidebarActions.setSidebarExpandedOnHover());
    },
    setCollapsedOnHover: () => {
        dispatch(SidebarActions.setSidebarCollapsedOnHover());
    },
    onLogout: () => {
        dispatch(AuthActions.logoutUserAction());
    },
    handleClickMenuItem: (item) => {
        dispatch(SidebarActions.setSidebarHandleClickMenuItem(item));
    },
    getSyllabus: (cuId) => {
        dispatch(VideoActions.getSyllabus(cuId));
    }

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar);


// WEBPACK FOOTER //
// ./src/containers/General/SidebarContainer.js